import { useHistory } from 'react-router-dom'

import { IconButton, Layout } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'

import {
  BidState,
  hasCarrierAcceptedRfp,
  isAwardFinished,
  type RfpSummary,
} from '../domain/RfpSummary'
import { ActionButton } from './RfpSummaryListItemAction.styles'

export type RfpSummaryListItemActionProps = {
  rfpSummary: RfpSummary
}

export function RfpSummaryListItemAction({ rfpSummary }: RfpSummaryListItemActionProps) {
  const { bidState, carrierInviteState, inviteLinkUuid, awardedLaneProposalsCount } = rfpSummary

  const { push: navigate } = useHistory()

  function handleDetailsClick() {
    navigate(`/portal/rfp/${inviteLinkUuid}`)
  }

  function handleFeedback() {
    navigate(`/portal/rfp/${inviteLinkUuid}/feedback`)
  }

  function handleBidClick() {
    if (!hasCarrierAcceptedRfp(carrierInviteState)) {
      navigate(`/portal/rfp/${inviteLinkUuid}?accepted=true`)
      return
    }

    navigate(`/portal/rfp/${inviteLinkUuid}`)
  }

  function handleReviewClick() {
    if (isAwardFinished(carrierInviteState)) {
      navigate(`/portal/rfp/${inviteLinkUuid}/award/confirmation`)
      return
    }

    navigate(`/portal/rfp/${inviteLinkUuid}/award`)
  }

  if (bidState === BidState.Open) {
    return (
      <Layout.Group>
        <ActionButton onClick={handleBidClick} variant="primary">
          Bid
        </ActionButton>
      </Layout.Group>
    )
  }

  if (bidState === BidState.Results && awardedLaneProposalsCount > 0) {
    return (
      <Layout.Group align="center">
        <IconButton onClick={handleFeedback}>
          <Icon width={16} height={16} name="eye" />
        </IconButton>
        <ActionButton variant="primary" onClick={handleReviewClick}>
          Review
        </ActionButton>
      </Layout.Group>
    )
  }

  if (bidState === BidState.Closed) {
    return (
      <IconButton onClick={handleFeedback}>
        <Icon width={16} height={16} name="eye" />
      </IconButton>
    )
  }

  return (
    <IconButton onClick={handleDetailsClick}>
      <Icon width={16} height={16} name="eye" />
    </IconButton>
  )
}
